<template>
  <div>
    <div
      class="d-flex align-items-center main-title-background ps-2 py-1 mouse-hover"
    >
      <div class="d-flex fw-bold ps-2 flex-grow-1">
        {{ 'Filters' }}
      </div>
      <button
        class="focus-style-cross d-flex fw-bold px-3 me-2 mouse-hover"
        @click="removeFilterProperty(ruleRroperty.filter)"
      >
        X
      </button>
    </div>
    <div>
      <template v-if="!isLoading">
        <RuleMinMaxCountFilterMultiSelectCondition
          v-if="filter.labels"
          :parent-rule-reference="parentRuleReference"
          :filter-rule-reference="filter.reference"
          :property="filter.labels"
          :property-name="'labels'"
          :title="trans(`subscription.validation_rules.filters.filter_labels`)"
          :multi-select-label="trans(`subscription.validation_rules.filters.select_labels`)"
          :type="'label'"
          :selection-array="labels"
        />
        <RuleSmallButton
          v-else
          :title="trans(`subscription.validation_rules.rule_property_add`, { name: trans(`subscription.validation_rules.filters.filter_labels`) })"
          class="m-3 focus-style btn-success"
          @click.native="addRuleProperty('labels')"
        />
        <RuleMinMaxCountFilterMultiSelectCondition
          v-if="filter.questions"
          :parent-rule-reference="parentRuleReference"
          :filter-rule-reference="filter.reference"
          :property="filter.questions"
          :property-name="'questions'"
          :title="trans(`subscription.validation_rules.filters.filter_questions`)"
          :multi-select-label="trans(`subscription.validation_rules.filters.select_questions`)"
          :type="'question-template'"
          :selection-array="questions"
        />
        <RuleSmallButton
          v-else
          :title="trans(`subscription.validation_rules.rule_property_add`, { name: trans(`subscription.validation_rules.filters.filter_questions`) })"
          class="m-3 focus-style btn-success"
          @click.native="addRuleProperty('questions')"
        />
        <RuleMinMaxCountFilterMultiSelectCondition
          v-if="filter.answers"
          :parent-rule-reference="parentRuleReference"
          :filter-rule-reference="filter.reference"
          :property="filter.answers"
          :property-name="'answers'"
          :title="trans(`subscription.validation_rules.filters.filter_answers`)"
          :multi-select-label="trans(`subscription.validation_rules.filters.select_answers`)"
          :type="'question-template-answer'"
          :selection-array="answers"
        />
        <RuleSmallButton
          v-else
          :title="trans(`subscription.validation_rules.rule_property_add`, { name: trans(`subscription.validation_rules.filters.filter_answers`) })"
          class="m-3 focus-style btn-success"
          @click.native="addRuleProperty('answers')"
        />
      </template>
      <Loader
        v-else
        class="pb-3"
      />
    </div>
  </div>
</template>

<script>
import { RULE_PROPERTY } from '@/constants'
import ruleMixin from '@/employees/components/Rule/utilities/mixins/ruleMixin'
import RuleMinMaxCountFilterMultiSelectCondition from '@/employees/components/Rule/RuleMinMaxCountFilterMultiSelectCondition'
import { buildFilterQuestionsType } from '@/employees/components/Rule/utilities/builder/ruleBuilder'
import { mapState } from 'vuex'
export default {
  name: 'RuleMinMaxCountFilterCondition',
  components: {
    RuleMinMaxCountFilterMultiSelectCondition,
  },
  mixins: [ruleMixin],
  props: {
    parentRuleReference: {
      required: true,
      type: String,
    },
    filter: {
      required: true,
      type: Object,
    },
  },
  data () {
    return {
      ruleRroperty: RULE_PROPERTY,
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      missingLabelIds (state) {
        return this.objectMissingIds(state.labelGroups.labels, this.filter.labels.in)
      },
      labels (state) {
        return this.filter.labels.in.map((id) => {
          if (!state.labelGroups.labels.hasOwnProperty(id)) {
            return {}
          }
          const label = state.labelGroups.labels[id]
          const labelGroup = state.labelGroups.labelGroups[label.labelGroup]
          return {
            id: id,
            name: `${labelGroup.name} / ${label.name}`,
          }
        })
      },
      missingQuestionIds (state) {
        return this.objectMissingIds(state.questionTemplates.questionTemplates, this.filter.questions.in)
      },
      questions (state) {
        return this.filter.questions.in.map((id) => {
          if (!state.questionTemplates.questionTemplates.hasOwnProperty(id)) {
            return {}
          }
          const result = state.questionTemplates.questionTemplates[id]
          return {
            id: id,
            name: result.name,
            type: result.type,
          }
        })
      },
      missingAnswerIds (state) {
        return this.objectMissingIds(state.questionTemplates.questionTemplateAnswers, this.filter.answers.in)
      },
      answers (state) {
        return this.filter.answers.in.map((id) => {
          if (!state.questionTemplates.questionTemplateAnswers.hasOwnProperty(id)) {
            return {}
          }
          const questionTemplateAnswer = state.questionTemplates.questionTemplateAnswers[id]
          const questionTemplate = state.questionTemplates.questionTemplates[questionTemplateAnswer.questionTemplate]
          return {
            id: id,
            name: `${questionTemplate.name} / ${questionTemplateAnswer.answer}`,
          }
        })
      },
    }),
  },
  async mounted () {
    //* This mechanism is build, because when getting subscribables the question templates and question template answers
    //* can not currently be retrieved without rewriting a lot of back-end code
    this.isLoading = true
    const promiseArray = []
    if (this.filter.labels && this.missingLabelIds.length > 0) {
      promiseArray.push(this.$store.dispatch('getLabels', {
        queryParams: {
          filter: {
            id: this.missingLabelIds,
          },
          include: ['labelGroup.labels.labelGroup'],
        },
      }))
    }
    if (this.filter.questions && this.missingQuestionIds.length > 0) {
      promiseArray.push(this.$store.dispatch('getQuestionTemplates', {
        queryParams: {
          filter: {
            id: this.missingQuestionIds,
          },
        },
      }))
    }
    if (this.filter.answers && this.missingAnswerIds.length > 0) {
      promiseArray.push(this.$store.dispatch('getQuestionTemplateAnwsers', {
        queryParams: {
          filter: {
            id: this.missingAnswerIds,
          },
          include: ['questionTemplate.answers.questionTemplate'],
        },
      }))
    }
    await Promise.allSettled(promiseArray)
    this.isLoading = false
  },
  methods: {
    removeFilterProperty (rulePropertyEnum) {
      this.rulePropertyValueDelete(this.parentRuleReference, rulePropertyEnum)
    },
    addRuleProperty (rulePropertyEnum) {
      this.rulePropertyValueAdd(this.filter.reference, rulePropertyEnum, buildFilterQuestionsType())
    },
    objectMissingIds (object, idArray) {
      const missingIds = []
      for (let i = 0; i < idArray.length; i++) {
        if (!object.hasOwnProperty(idArray[i])) {
          missingIds.push(idArray[i])
        }
      }
      return missingIds
    },
  },
}
</script>

<style lang="scss" scoped>
.main-title-background {
  background-color: rgba(0, 0, 0, 0.2);
}
.mouse-hover {
  cursor: pointer
}
/deep/
.col-xs-12 {
  float: none;
}
.focus-style{
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5) !important;
  }
}
.focus-style-cross {
  border-style: hidden;
  background: none;
  &:focus {
    border-color: #1b89ff;
    border-width: 1px;
    border-style: solid;
    box-shadow: 0 0 5px rgba(27, 137, 255, .5);
  }
}
</style>
